import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import useUserName from '../../common/hooks/useUserName';

import { posTableAPI } from '../../api/posTablesAPI'
import POSTablesImg from '../../assets/images/tables.png';

import Spinner from "../../components/spinner/spinner";

import './posTables.css';

export default function POSTables() {
    const [isProcessing, setIsProcessing] = useState(false);
    const [tables, setTables] = useState([]);

    const didMount = useRef(false);
    const { userName } = useUserName();

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            setIsProcessing(true);
            posTableAPI.getPOSTables().then((data) => setTables(data)).finally(() => setIsProcessing(false));
        }
    }, [])

    return (
        <>
            <div class="text-center">
                {isProcessing === true && <Spinner />}
            </div>
            <div className="row">
                {isProcessing === false &&
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 posTable__div">
                        {
                            <>
                                <ul className="nav nav-tabs mb-3">
                                    {Object.keys(
                                        tables.reduce((acc, t) => {
                                            (acc[t.category] = acc[t.category] || []).push(t);
                                            return acc;
                                        }, {})
                                    ).map((category, index) => (
                                        <li className="nav-item" key={category}>
                                            <button
                                                className={`nav-link btn btn-primary ${index === 0 ? "active" : ""}`}
                                                data-bs-toggle="tab"
                                                data-bs-target={`#tab-${category}`}
                                                type="button"
                                            >
                                                {category}
                                            </button>
                                        </li>
                                    ))}
                                </ul>

                                <div className="tab-content">
                                    {Object.entries(
                                        tables.reduce((acc, t) => {
                                            (acc[t.category] = acc[t.category] || []).push(t);
                                            return acc;
                                        }, {})
                                    ).map(([category, items], index) => (
                                        <div
                                            key={category}
                                            className={`tab-pane fade ${index === 0 ? "show active" : ""}`}
                                            id={`tab-${category}`}
                                        >
                                            <div className="d-flex flex-wrap gap-3">

                                                {items.map((data) => (
                                                    <Link to={"/postouch"} key={data.tableNo}
                                                        state={{
                                                            selectedTableNo: data.tableNo,
                                                            backNavigationPath: "/steward/mainmenu",
                                                            selectedMode: 'Steward - ' + userName
                                                        }}>
                                                        <div className={"card posTables__card pb-0 " + (data.isOccupied ? "posTables__card--occupied" : "")}>
                                                            <img className="card-img-top posTables__img" src={POSTablesImg} alt="Card" />
                                                            <div className="card-body p-0 text-center">
                                                                <p className="card-title p-0 m-0">Table # {data.tableNo}</p>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                ))}

                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        }

                    </div>
                }
            </div>
        </>
    );
}